import React, { useEffect, useState } from "react";
import Header from "../../../Components/adminDashboard/Header/Header";
import combinedServices from "../../../shared/services/user-service";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { Spinner } from "reactstrap";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Swal from "sweetalert2";

function GlobalRaceAdmins() {
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [inputbox, setInputbox] = useState(false);
  const [subMember, setSubMember] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    getAllAdmins();
    fetchUsers();
  }, []);

  const getAllAdmins = async () => {
    setIsLoading(true);
    try {
      const response = await combinedServices.getAllGlobalRaceAdmins();
      setAdmins(response.data || []);
    } catch (error) {
      console.error("Error fetching admins:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      let eventSubMember = await combinedServices.getAllUserForManageEntries();
      if (eventSubMember.status === 200) {
        const userList = eventSubMember.data
          .filter((user) => user.user_status === "active")
          .map((user) => ({
            name: `${user.user_firstname} ${user.user_lastname}`,
            id: user.id,
          }));
        setSubMember(userList);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleCreateAdmin = async () => {
    if (!selectedUser) {
      Swal.fire("Error", "Please select a user.", "error");
      return;
    }

    setIsLoading(true);
    try {
      const response = await combinedServices.createGlobalRaceAdmin({
        user_id: selectedUser.id,
      });
      if (response) {
        setOpenDialog(false);
        setSelectedUser(null);
        getAllAdmins();
        Swal.fire("Success", "Administrator added successfully!", "success");
      }
    } catch (error) {
      console.error("Error creating admin:", error);
      Swal.fire("Error", "Failed to add administrator.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAdmin = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      setIsLoading(true);
      try {
        const response = await combinedServices.deleteGlobalRaceAdmin(id);
        if (response) {
          getAllAdmins();
          Swal.fire("Deleted!", "Administrator has been deleted.", "success");
        }
      } catch (error) {
        console.error("Error deleting admin:", error);
        Swal.fire("Error", "Something went wrong.", "error");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSearchBox = (e) => {
    setSearchUser(e.target.value);
    setInputbox(e.target.value !== "");
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setSearchUser(user.name);
    setInputbox(false);
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight">
        <div className="dbMid dbInner">
          <div className="flexBox spacebetween topHdBox">
            <h3>Global Race Administrators</h3>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenDialog(true)}
              style={{ margin: "20px" }}
            >
              Add New Administrator
            </Button>
          </div>
          <div className="flexBox spacebetween">
            <div className="pgBox whtBox">
              {isLoading ? (
                <div className="text-center mt-4 loadMore">
                  <Spinner color="primary" />
                </div>
              ) : admins.length > 0 ? (
                <table style={{ width: "100%", marginTop: "20px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "lightgray", height: "40px" }}>
                      <th style={{ textAlign: "left", padding: "10px" }}>User ID</th>
                      <th style={{ textAlign: "left", padding: "10px" }}>Name</th>
                      <th style={{ textAlign: "left", padding: "10px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {admins.map((admin) => (
                      <tr key={admin.id}>
                        <td>{admin.user.id}</td>
                        <td>
                          {admin.user.firstname} {admin.user.lastname}
                        </td>
                        <td>
                          <IconButton aria-label="delete" onClick={() => handleDeleteAdmin(admin.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div style={{ textAlign: "center" }}>No Race Administrators Assigned</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add New Admin Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Add New Global Race Administrator</DialogTitle>
        <DialogContent>
          <div className="eventInner searchBox membersList-box">
            <input
              type="text"
              className="searchUser"
              id="searchUser"
              placeholder="Search user"
              onChange={handleSearchBox}
              value={searchUser}
              autoComplete="off"
            />
            {inputbox && (
              <ul className="flexBox eventForm" id="toggleText">
                {subMember
                  .filter(
                    (val) =>
                      searchUser === "" ||
                      val.name.toLowerCase().includes(searchUser.toLowerCase())
                  )
                  .map((user) => (
                    <li key={user.id} onClick={() => handleSelectUser(user)}>
                      {user.name}
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleCreateAdmin} disabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : "Add Administrator"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default GlobalRaceAdmins;
